import {
  Skill,
  Industry,
  Language,
} from "@/generated/graphql";
import ItemChipsData from "@/entities/ItemChipsData";

export function getIndustriesForChips(industries: Industry[]): ItemChipsData[] {
  if (!industries.length) {
    return [];
  }
  return industries.map(industry => {
    return {
      id: industry.id,
      name: industry.name,
    }
  });
}
export function getSkillsForChips(skills: Skill[]): ItemChipsData[] {
  if (!skills.length) {
    return [];
  }
  return skills.map(skill => {
    return {
      id: skill.id,
      name: skill.name!,
    }
  });
}

export function getTagsForChips(tags): ItemChipsData[] {
  if (!tags.length) {
    return [];
  }
  return tags.map(tag => {
    return {
      id: tag.id,
      name: tag.name!,
    }
  });
}

export function getLanguagesForChips(languages: Language[] ): ItemChipsData[] {
  if (!languages.length) {
    return [];
  }
  return languages.map(language => {
    return {
      id: language.id,
      name: language.name,
    }
  });
}
